import ApiResponse from "@core/types/apiResponse";
import { register } from "@features/auth/api/authApi";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import { RegisterRequest } from "../types/registerRequest";

export const registerAsync = async (request: RegisterRequest): Promise<ApiResponse<ApiMessageResponse>> => {
    return register(request);
};
